import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AdminPageTabList, SettingsGeneralDetails, SettingsImageGallery } from "../components";
import { Dashboard } from "./DashboardPage";

const tabs = [
  {
    title: "General Details",
  },
  {
    title: "Admins",
  },
  {
    title: "Billing",
  },
  {
    title: "Image Gallery",
  },
];

export const SettingsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const businesses = useSelector((state: any) => state.business);
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const renderActiveTabContent = () => {
    switch (activeTab.title) {
      case "General Details":
        return <SettingsGeneralDetails />;
      case "Admins":
        return <div>Admins page coming soon!</div>;
      case "Billing":
        return <div>Billing page coming soon!</div>;
      case "Image Gallery":
        return <SettingsImageGallery />;
      default:
        return <div>No page created yet for this tab</div>;
    }
  };

  return (
    <Dashboard>
      <div style={{ marginTop: 24 }}>
        <AdminPageTabList tabs={tabs} onSelect={setActiveTab} activeTab={activeTab} />
      </div>
      <div style={{ marginTop: 30 }}>{renderActiveTabContent()}</div>
    </Dashboard>
  );
};
